import React, { useState, useEffect } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
  Box,
  MenuItem
} from '@mui/material';
import {
  dialogFormPaperSx,
  dialogFormScrollContentSx,
  dialogFormTitleSx,
  dialogFormActionsSx
} from '../utils/dialogFormLayout';

const CATEGORIES = ['Outfit', 'Bondage', 'Toys', 'Dolls', 'Other'];

const RealItemForm = ({ open, onClose, onSubmit, item = null, isEdit = false }) => {
  const [name, setName] = useState('');
  const [category, setCategory] = useState('Other');

  useEffect(() => {
    if (item) {
      setName(item.name || '');
      setCategory(item.category || 'Other');
    } else {
      setName('');
      setCategory('Other');
    }
  }, [item]);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (name.trim()) {
      onSubmit({
        name: name.trim(),
        category
      });
      setName('');
      setCategory('Other');
      onClose();
    }
  };

  const handleClose = () => {
    setName('');
    setCategory('Other');
    onClose();
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      maxWidth="sm"
      fullWidth
      PaperProps={{ sx: dialogFormPaperSx }}
    >
      <DialogTitle sx={dialogFormTitleSx}>
        {isEdit ? 'Edit Real Item' : 'Create Real Item'}
      </DialogTitle>
      <Box
        component="form"
        onSubmit={handleSubmit}
        sx={{ display: 'flex', flexDirection: 'column', flex: '1 1 auto', minHeight: 0, overflow: 'hidden' }}
      >
        <DialogContent sx={(theme) => dialogFormScrollContentSx(theme)}>
          <TextField
            autoFocus
            margin="dense"
            label="Item Name"
            fullWidth
            variant="outlined"
            value={name}
            onChange={(e) => setName(e.target.value)}
            required
            placeholder="e.g. Lipstick, Dress"
            sx={{ mb: 2 }}
          />
          <TextField
            margin="dense"
            label="Category"
            fullWidth
            variant="outlined"
            select
            value={category}
            onChange={(e) => setCategory(e.target.value)}
          >
            {CATEGORIES.map((cat) => (
              <MenuItem key={cat} value={cat}>{cat}</MenuItem>
            ))}
          </TextField>
        </DialogContent>
        <DialogActions sx={dialogFormActionsSx}>
          <Button onClick={handleClose}>Cancel</Button>
          <Button type="submit" variant="contained">
            {isEdit ? 'Save' : 'Create'}
          </Button>
        </DialogActions>
      </Box>
    </Dialog>
  );
};

export default RealItemForm;
